import React, { useContext, useState, useEffect, useRef } from 'react'
import BuyerContext from '../../Product/context/buyer/buyerContext'
import AuthContext from '../../Product/context/auth/authContext'
import PluginContext from '../../Product/context/plugin/pluginContext'
import ProductContext from '../../Product/context/product/productContext'
import NoRecordsFound from '../../Product/components/atoms/NoRecordsFound'
import SlidePanel from '../SlidePanel'
import { connect } from 'react-redux'
import {
    currencyFormat,
    dateFormatFrontDay,
    handleRedirectInternal,
} from '../../Product/common/components'
import { Pagination } from '@material-ui/lab'
import { Link, useHistory } from 'react-router-dom'
import Timer from '../../Product/common/timer'
import PrimaryButton from '../../Product/components/atoms/PrimaryButton'
import { imageError, getImageurl } from '../../utils/commonFunctions'
import MultisellerSlider from '../SlidePanel/MultisellerSlider'
import Loader from '../../assets/loader'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'
import SecondaryButton from '../../Product/components/atoms/SecondaryButton'
import axios from 'axios'
import AlertContext from '../../Product/context/alert/alertContext'
import RetractBid from './RetractBid'
import CurrencyConverterFormat from '../../utils/CommonFunctionality/CurrencyConverter/CurrencyConverterFormat'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import Popup from '../../Product/components/organisms/Popup'
import UserContext from '../../Product/context/user/userContext'
import StripeCardContext from '../../Product/context/stripe/card/cardContext'
import Dispute from './Dispute'
import RequestRefund from './RequestRefund'
import Requestplugin from './Requestplugin'
import AddFeedback from '../../utils/CommonFunctionality/Feedback/AddFeedback'
import AdditionalPayment from './AdditionalPayment'
import CustomDialog from '../../Product/components/organisms/Dialog'
import InvoiceMessage from '../../utils/CommonFunctionality/Message/InvoiceMessage'
import { Chip } from '@material-ui/core'
import { socket } from '../../Product/common/socket'
import CheckBox from '../../Product/components/atoms/CheckBox'
import MultiPickup from '../../utils/CommonFunctionality/Scheduler/MultiPickup'
import CustomSelect from '../../Product/components/atoms/Inputs/CustomSelect'
import LotListProduct from '../ProductCard/lotListProduct'
import './Style.css'
import { ShoppingCart } from '@material-ui/icons'
import DirectStripeContext from '../../Product/context/directStripe/directStripeContext'
import SchedulePickupContext from '../../Product/context/plugin/schedulePickup/schedulePickupContext'
// import Requestplugin from './Requestplugin'
const InvoiceRecords = (props) => {
    const buyerContext = useContext(BuyerContext)
    const productContext = useContext(ProductContext)
    const pluginContext = useContext(PluginContext)
    const userContext = useContext(UserContext)
    const authContext = useContext(AuthContext)
    const schedulePickupContext = useContext(SchedulePickupContext)
    const params = new URLSearchParams(window.location.search.substring(1))
    const [auction_list, setAuctionlist] = useState([])
    const [locationList, setLocationList] = useState([])
    const {
        getAllShippingAddress,
        all_shipping_address,
        static_page,
        getStaticPage,
        responseStatus: responseStatusUser,
    } = userContext
    const {
        getAbandonedOrders,
        responseStatus: pluginResponseStatus,
        get_warranty_list,
        warranty_list,
        extendPickupPayment,
    } = pluginContext

    const history = useHistory()
    const { t } = useTranslation()
    const {
        buyer_allproducts,
        buyer_allproducts_temp,
        getAllBuyerProducts,
        updateVideoCount,
        product_view,
        getViewProduct,
        check_get_shipping_rate_api,
        shipping_rate_calculation,
        clear_ship_station_amount,
        getAllMakeRequest,
        list_make_request,
        markasrecived,
        getAllAuctionProducts,
        getAllWarehouseLocations,
        all_auctions,
        all_locations,
        responseStatus: buyerresponsestatus,
        clearResponse,
    } = buyerContext
    const {
        get_all_card_details,
        getAllStripeCards,
        responseStatus: cardResponseStatus,
        clearResponse: cardClearResponse,
    } = useContext(StripeCardContext)
    const { usercards } = useContext(DirectStripeContext)
    const { isAuthenticated, user, updateMessageCount, userCount } = authContext
    const {
        getAllTimings,
        updateDefaultTimings,
        addSchedule,
        responseStatus: schedulePickupResponse,
        all_timings,
        clearResponse: schedulePickupClear,
    } = schedulePickupContext
    const buyerAllProductsRef = useRef(buyer_allproducts)
    const userCountRef = useRef(userCount)
    const userRef = useRef(user)
    const [warrantlyList, setWarrantyList] = useState([])
    const [timingsInv, setTimingsInv] = useState({
        default: [],
        scheduled: [],
        all_locations: [],
    })
    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'
    const isWizardTheme = document.body.classList[1] == 'wizardTheme'
    const isBargainsProject = global.storeConfigration?.bodyClass2?.value === 'bargainsClass'
    const isBuyBestProject = global.storeConfigration?.bodyClass2?.value === 'buyBestProject'

    const mountedRef = useRef()
    const [initialLoad, setInitialLoad] = useState(true)

    useEffect(() => {
        buyerAllProductsRef.current = buyer_allproducts
        userCountRef.current = userCount
        userRef.current = user
    })
    const [btnloading, setBtnloading] = useState(false)

    const [loading, setLoading] = useState(true)
    const [Items, setData] = useState([])
    const [selectedProduct, setSelectedProduct] = useState(null)
    const [abandonedOrders, setAbandonedOrders] = useState({
        products: [],
        page: 1,
        limit: 10,
        totaProducts: 0,
    })
    const [totalItems, setTotalItem] = useState(0)
    const [toInvoice, settoInvoice] = useState(false)
    const [toInvoiceID, settoInvoiceID] = useState(false)
    const [popup_open, setPopupopup] = useState(false)
    const [refundTrigger, setRefundTrigger] = useState(false)
    const [feedbackOpen, setFeedbackOpen] = useState(false)
    const [feedbackItem, setFeedbackItem] = useState({})
    const [additionalPayOpen, setAdditionalPayOpen] = useState(false)
    const [additionalPayItem, setAdditionalPayItem] = useState({})
    const [popupchecked, setPopupchecked] = useState(false)
    const [termscondtions, setTermscondition] = useState('')
    const [selectAddress, setSelectAddress] = useState([])
    const [display_address, setDisplayAddress] = useState({})
    const [messageChecked, setMessageChecked] = useState(false)
    const [localSelectedDate, setLocalSelectedDate] = useState(null)
    const [date_closed, setDateClosed] = useState(new Date())
    const [paid_date, setPaidDate] = useState(new Date())
    const [lotof, setLotof] = useState('')
    const [showInvoice, setShowInvoice] = useState('')
    const [buynowId, setBuynowId] = useState({})
    const { responseStatus, similar_products_qty, getSimilarProductsQty, clearSimilarQty } =
        productContext
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const [search, setSearch] = useState({
        status: props.page,
        sh_limit: 100,
        page: 1,
        order: props.page == 'bidlost' ? 2 : 1,
        ftpImage: true,
        buynow_only_io: props.page == 'buynow' ? 1 : undefined,
        auction_only_io:
            props.page == 'bidwon' && global.pluginConfiguration?.make_an_offer?.enable
                ? 1
                : undefined,
        search: '',
        buynow_with_qty:
            props.page == 'buynow' && global?.storeConfigration?.buy_now_with_qty?.value
                ? 1
                : undefined,
        get_msg_count: global?.storeConfigration?.unique_slot4?.value == 1 ? 1 : 0,
        sch_type: '',
        auction_lot_filter: global.storeConfigration?.auction_dashboard_with_filter?.value ? 1 : 0,
        paid: 'all',
        lotof: '',
        from: 'invoice',
        warehouse_location: '',
        need_buynow: props.gfTransaction ? 1 : undefined,
        is_transpage: props.gfTransaction ? 1 : 0,
        primebids: props.isPrime ? 1 : undefined,
    })

    const [searchValue, setSearchValue] = useState('')
    const [invoiceId, setInvoiceId] = useState([])
    const [scheduleInvoiceId, setScheduleInvoiceId] = useState([])
    const [scheduleLocationId, setScheduleLocationId] = useState([])
    const [printInvoiceId, setPrintInvoiceId] = useState([])
    const [trigger, setTrigger] = useState(false)
    const [similarQty, setSimilarQty] = useState([])
    const [initial, setInitial] = useState(true)
    const [checkoutLength, setCheckoutLength] = useState(0)
    const [scheduleLength, setScheduleLength] = useState(0)
    const [openSchedule, setOpenSchedule] = useState(false)
    const [openPickupExtension, setOpenPickupExtension] = useState(false)
    const [extendInvoices, setExtendInvoices] = useState([])
    const [allData, setAllData] = useState([])
    const [loader, setCardLoading] = useState(false)
    const [cardData, setCardData] = useState('nocard')
    const [paymentLoading, setPaymentLoading] = useState(false)
    const primeBidsTheme = document.body.className == 'liquidationTwo primeBids'

    const isLOAProject = document.querySelector('body').classList.contains('LotsAuction')

    const onHandlePage = (event, value) => {
        if (props.abandoned) {
            getAbandonedOrders({
                user_id: user?.id,
                limit: 10,
                page: value,
            })
            setAbandonedOrders({
                ...abandonedOrders,
                page: value,
            })
        } else {
            setSearch({ ...search, page: value })
            if (props.page == 'make_an_offer') {
                getAllMakeRequest({
                    user_id: user?.id,
                    status: 'Accepted',
                    limit: 10,
                    page: value,
                })
            }
        }
    }
    const addBusinessDays = (location_id, date, daysToAdd) => {
        let warehouseWorkingDays = []

        if (all_timings.all_locations.length > 0) {
            warehouseWorkingDays = all_timings?.all_locations.filter(
                (item) => item.id == location_id,
            )
        }

        if (!warehouseWorkingDays.length) return moment.utc(date).local() // fallback

        // Extract the general schedule
        const generalSchedule = warehouseWorkingDays[0]?.range_key[0]?.general || []

        // Map day names to indices
        const dayNameToIndex = {
            Sunday: 0,
            Monday: 1,
            Tuesday: 2,
            Wednesday: 3,
            Thursday: 4,
            Friday: 5,
            Saturday: 6,
        }

        // Build a Set of open day indices
        const openDayIndices = new Set(
            generalSchedule
                .filter((day) => day.Status === 'Open')
                .map((day) => dayNameToIndex[day.Day]),
        )

        let result = moment.utc(date).local()
        let addedDays = 0

        while (addedDays < daysToAdd) {
            result.add(1, 'days')
            if (openDayIndices.has(result.day())) {
                addedDays++
            }
        }

        return result
    }

    const onChangeCard = (e) => {
        e.target.checked ? setCardData(e.target.value) : setCardData('nocard')
    }
    const categoryTypes = {}
    global.allCategories.map((catgeory) => (categoryTypes[catgeory.id] = catgeory))
    useEffect(() => {
        if (props.page != 'make_an_offer') {
            if (props.gfTransaction) {
                if (buyer_allproducts.from == 'bidwon') {
                    setLoading(false)
                    setData(buyer_allproducts.results)
                    setTotalItem(buyer_allproducts.total_pagecnt)
                    setScheduleInvoiceId([])
                    setScheduleLength(0)
                }
            } else {
                setLoading(false)
                setData(buyer_allproducts.results)
                setTotalItem(buyer_allproducts.total_pagecnt)
                setScheduleInvoiceId([])
                setScheduleLength(0)
            }
        }
    }, [buyer_allproducts])
    useEffect(() => {
        if (responseStatus && responseStatus !== '') {
            if (responseStatus === 'buynow_updated_successfull') {
                getAllBuyerProducts(search)
            } else {
            }
        } else {
        }
    }, [responseStatus])
    useEffect(() => {
        if (all_locations.length && initialLoad) {
            getAllBuyerProducts(
                {
                    ...search,
                    warehouse_location: '',
                },
                props?.cancelToken,
            )
            setInitialLoad(false)
        }
    }, [all_locations, initialLoad])
    useEffect(() => {
        if (
            user &&
            global?.pluginConfiguration?.extended_pickup?.enable == 1 &&
            user.card_paymentid
        ) {
            const getData = async () => {
                getAllStripeCards({
                    account_id: process.env.REACT_APP_AUCTIONPAYID,
                    customer_id: user.card_paymentid,
                    object: 'card',
                })
            }
            getData()
        }
    }, [user])
    useEffect(() => {
        if (global?.pluginConfiguration?.extended_pickup?.enable == 1 && get_all_card_details) {
            setAllData(get_all_card_details.records)
        }
    }, [get_all_card_details])
    useEffect(() => {
        if (global?.pluginConfiguration?.extended_pickup?.enable == 1 && usercards.length) {
            setAllData(usercards)
        }
    }, [usercards])
    // useEffect(() => {
    //     // if (user) {
    //     socket.on('insertMessages_count', (data) => {
    //         if (buyerAllProductsRef.current?.results?.length) {
    //             buyerAllProductsRef.current?.results.map((val) => {
    //                 if (
    //                     userRef.current?.id == data.to_id &&
    //                     data.project_id == val.common_invoice
    //                 ) {
    //                     console.log(val, 'val')
    //                     val.msg_count += 1
    //                 }
    //             })
    //             updateVideoCount(buyerAllProductsRef.current)
    //         }
    //     })
    //     // }

    //     return () => {
    //         console.log('000000000000')
    //         socket.off('insertMessages_count', (data) => {
    //             return data
    //         })
    //     }
    // }, [])
    useEffect(() => {
        if (loader && cardResponseStatus) {
            if (
                cardResponseStatus.from === 'card_source_create' ||
                cardResponseStatus.from === 'card_source_update' ||
                cardResponseStatus.from === 'card_source_delete'
            ) {
                if (cardResponseStatus.status === 'success') {
                    setCardLoading(false)
                    cardClearResponse()
                }
            }
        }
    }, [cardResponseStatus])

    useEffect(() => {
        if (buyerresponsestatus) {
            if (buyerresponsestatus.from == 'marke_as_recived') {
                setBtnloading(false)
                if (buyerresponsestatus.status == 'error') {
                    setAlert(buyerresponsestatus?.message?.message, buyerresponsestatus.status)
                } else {
                    if (buyerresponsestatus?.result?.message) {
                        setAlert(buyerresponsestatus.result.message, buyerresponsestatus.status)

                        getAllBuyerProducts(search)
                    }
                }
                clearResponse()
            }
        }
    }, [buyerresponsestatus])

    useEffect(() => {
        if (props.page != 'make_an_offer') {
            setLoading(true)
            if (isAuthenticated) {
                if (props.cancelRequest) {
                    props.cancelRequest.cancel()
                }

                if (props.setCancelRequest) {
                    props.setCancelRequest(props?.cancelToken)
                }
                var sen_buyer_data = search
                if (mountedRef.current) {
                    getAllBuyerProducts(sen_buyer_data, props?.cancelToken)
                    if (!isVarifiedGfTheme && !primeBidsTheme) {
                        getAllBuyerProducts({
                            ...sen_buyer_data,
                            from: undefined,
                            store_another: 1,
                        })
                    }
                }
            }
        }
    }, [search, isAuthenticated, refundTrigger, trigger])
    useEffect(() => {
        if (isAuthenticated && (search.warehouse_location || search.warehouse_location == '')) {
            if (!isVarifiedGfTheme) {
                getAllAuctionProducts({
                    site_id: global?.storeDetails?.site_id ? global.storeDetails.site_id : '',
                    type: 2,
                    user_id: user?.id,
                    sch_type: '',
                    warehouse_location: search.warehouse_location,
                })
            }
            var sen_buyer_data = search

            sen_buyer_data.lotof = localStorage.getItem('lotof')
                ? localStorage.getItem('lotof')
                : undefined
            setLotof(localStorage.getItem('lotof') ? localStorage.getItem('lotof') : '')
            localStorage.removeItem('lotof')
        }
    }, [isAuthenticated, search.warehouse_location])
    useEffect(() => {
        if (isAuthenticated) {
            getAllWarehouseLocations({
                site_id: global?.storeDetails?.site_id ? global.storeDetails.site_id : '',
                type: 2,
                user_id: user?.id,
                sch_type: props.sch_type,
            })
        }
    }, [isAuthenticated])

    useEffect(() => {
        if (all_auctions.length) {
            var reverse_auction = all_auctions.reverse()
            setAuctionlist([...reverse_auction])
        } else {
            setAuctionlist([])
        }
    }, [all_auctions])

    useEffect(() => {
        if (all_locations.length) {
            setLocationList(all_locations)
            if (!params.get('loc') && (props?.locationParam ?? 1))
                if (primeBidsTheme) {
                    handleRedirectInternal(
                        history,
                        `dashboard/purchase-history?loc=${all_locations[0]?.id}`,
                    )
                } else {
                    handleRedirectInternal(
                        history,
                        `dashboard/transactions?loc=${
                            global.storeDetails?.theme == 19 ? '1' : all_locations[0]?.id
                        }`,
                    )
                }
            // setSearch({
            //     ...search,
            //     warehouse_location: all_locations[0]?.id,
            // })
        } else {
            setLocationList([])
        }
    }, [all_locations])

    useEffect(() => {
        if (props.page == 'make_an_offer' && user) {
            setLoading(true)
            getAllMakeRequest({
                user_id: user?.id,
                limit: 10,
                page: 1,
            })
        }
        if (global?.pluginConfiguration?.warranty_return_sku?.enable == 1) {
            get_warranty_list(
                {
                    site_id: global.storeDetails?.site_id ? global.storeDetails.site_id : '',
                    user_id: user?.id,
                },
                'bidwon',
            )
        }
    }, [user])

    useEffect(() => {
        if (warranty_list?.from == 'bidwon') {
            if (warranty_list?.data?.records.length > 0) {
                setWarrantyList(warranty_list?.data?.records)
            } else {
                setWarrantyList([])
                // setAlert('Oops!.. You dont have Warranty SKU to initiate return.', 'error')
            }
        }
    }, [warranty_list])

    useEffect(() => {
        if (props.page == 'bidwon' && props.abandoned && user) {
            setLoading(true)
            getAbandonedOrders({
                user_id: user?.id,
                page: 1,
                limit: 10,
            })
        }
    }, [user])

    useEffect(() => {
        if (props.abandoned && pluginResponseStatus?.from == 'getAbandonedOrder') {
            if (pluginResponseStatus.status == 'error') {
                setAlert(pluginResponseStatus?.message?.message, pluginResponseStatus.status)
            } else {
                setAbandonedOrders({
                    ...abandonedOrders,
                    products:
                        pluginResponseStatus?.results !== null &&
                        pluginResponseStatus?.results.length > 0
                            ? pluginResponseStatus.results
                            : [],
                    totaProducts:
                        pluginResponseStatus?.total_count !== null &&
                        pluginResponseStatus?.total_count.length > 0
                            ? pluginResponseStatus.total_count[0].count
                            : 0,
                })
            }
        }
        if (pluginResponseStatus?.from == 'extendedPickup') {
            if (pluginResponseStatus.status == 'success') {
                setPaymentLoading(false)
                setOpenPickupExtension(false)
                setExtendInvoices([])

                getAllBuyerProducts(search)
                setAlert('Your Pickup Has Been Extended!', 'success')
            } else {
                setPaymentLoading(false)
                setOpenPickupExtension(false)
                setExtendInvoices([])
                setAlert('Something Went Wrong!', 'error')
            }
        }
    }, [pluginResponseStatus])

    useEffect(() => {
        if (global?.storeDetails?.site_id) {
            getAllTimings({
                site_id: global?.storeDetails?.site_id,
                random_id: '',
                id: '',
            })
        }
    }, [global?.storeDetails?.site_id])
    useEffect(() => {
        setTimingsInv({
            ...timingsInv,
            default: all_timings?.default_timings,
            all_locations: all_timings?.all_locations,
            scheduled: all_timings?.scheduled_timings,
        })
    }, [all_timings?.default_timings, all_timings?.scheduled_timings])

    useEffect(() => {
        if (!props.gfTransaction) {
            setLoading(false)
            if (props.page == 'make_an_offer') {
                if (list_make_request?.data?.length > 0) {
                    setData(list_make_request.data)
                    setTotalItem(list_make_request.totalcount)
                } else {
                    setData([])
                    setTotalItem(0)
                }
            }
        }
    }, [list_make_request])

    const handleClose = () => {
        getAllBuyerProducts(search)
        setSelectedProduct(null)
    }

    const handleClick = async (id) => {
        if (props.storeTheme == 'Liquidation_three' || props.storeTheme == 'Lotsofauctions') {
            handleRedirectInternal(history, `product/${id}`)
        } else {
            setSelectedProduct(id)
        }
    }

    const handleInvoiceChange = (id) => {
        var arr = invoiceId
        var arr2 = Items
        var temp = []
        var temp2 = []
        var stop = null
        if (arr.includes(id)) {
            temp = arr.filter((val) => val != id)
        } else {
            temp = [...arr, id]
        }
        temp.map((inv) => {
            arr2.filter((val) => val?.common_invoice == inv).map((value) => temp2.push(value))
        })
        if (isWizardTheme) {
            if (invoiceId.length) {
                temp2.map((val, i) => {
                    if (val.location_id != location) {
                        stop = true
                    }
                })
            }
            if (stop) {
                return setAlert('Kindly add same location invoice!', 'error')
            }
        }
        setInvoiceId(temp)
        setCheckoutLength(temp2.length)
    }
    const handleScheduleInvoiceChange = (id, location) => {
        var arr = scheduleInvoiceId
        var arr2 = Items
        var temp = []
        var temp2 = []
        var stop = null
        var date_close = new Date()
        var date_paid = new Date()
        var loc_id = null
        if (arr.includes(id)) {
            temp = arr.filter((val) => val != id)
        } else {
            temp = [...arr, id]
        }
        temp.map((inv) => {
            arr2.filter((val) => val?.common_invoice == inv).map((value) => {
                loc_id = value.location_id
                temp2.push(value)
            })
        })
        temp2.map((val, i) => {
            console.log(val.date_closed, 'val.date_closed')
            if (i === 0) {
                date_close = val.date_closed
                date_paid = val.buynowpaid_date
            }
        })
        if (scheduleInvoiceId.length) {
            temp2.map((val, i) => {
                if (val.location_id != location) {
                    stop = true
                }
            })
        }
        if (stop) {
            return setAlert('Kindly add same location invoice!', 'error')
        }
        setDateClosed(date_close)
        setPaidDate(date_paid)
        setScheduleLocationId(loc_id)
        setScheduleInvoiceId(temp)
        setScheduleLength(temp2.length)
    }

    const handleExtendPickup = (item, nopopup) => {
        setExtendInvoices((prev) => {
            if (prev.includes(item.common_invoice)) {
                return prev.filter((inv) => inv !== item.common_invoice)
            } else {
                if (!nopopup) {
                    setOpenPickupExtension(true)
                }
                return [...prev, item.common_invoice]
            }
        })
    }
    const handlePrintInvoiceChange = (id) => {
        var arr = printInvoiceId
        var arr2 = Items
        var temp = []
        if (arr.includes(id)) {
            temp = arr.filter((val) => val != id)
        } else {
            temp = [...arr, id]
        }
        temp.map((inv) => {
            arr2.filter((val) => val?.common_invoice == inv)
        })

        setPrintInvoiceId(temp)
    }
    const handleScheduleCheckinChange = (id, location) => {
        var arr = scheduleInvoiceId
        var arr2 = Items
        var temp = []
        var temp2 = []
        var stop = null
        if (arr.includes(id)) {
            temp = arr.filter((val) => val != id)
        } else {
            temp = [...arr, id]
        }
        temp.map((inv) => {
            arr2.filter((val) => val?.scheduled == inv).map((value) => temp2.push(value))
        })
        if (scheduleInvoiceId.length) {
            temp2.map((val) => {
                if (val.schedule_location_id != location) {
                    stop = true
                }
            })
        }
        if (stop) {
            return setAlert('Kindly add same location invoice!', 'error')
        }
        setScheduleInvoiceId(temp)
        setScheduleLength(temp2.length)
    }

    const handleSeeVideo = (item) => {
        setMessageChecked(true)
        setBuynowId(item)
        if (parseInt(item.msg_count) > 0) {
            updateMessageCount(
                parseInt(userCountRef?.current?.messageCount),
                parseInt(userCountRef?.current?.messageCountProjects) - parseInt(item.msg_count),
            )
            item.msg_count = 0
        }
    }
    const handleInvoiceChangeupdate = (id) => {
        var arr = invoiceId
        var arr2 = Items
        var temp = []
        var temp2 = []
        if (arr.includes(id)) {
            temp = arr.filter((val) => val != id)
        } else {
            temp = [...arr, id]
        }
        temp.map((inv) => {
            arr2.filter((val) => val?.common_invoice == inv && val?.status == 'Accepted').map(
                (value) => temp2.push(value),
            )
        })
        setInvoiceId(temp)
        setCheckoutLength(temp2.length)
    }
    const handleExtendedPickupPayment = async () => {
        // {
        //     "invoice_id": [
        //         {"id": "912898", "amount": "52"},
        //         {"id": "912898", "amount": "52"}
        //     ],
        //     "payment_details": {
        //         "source": "card_1RhAccAulnVHuRJhWANEPN7h",
        //         "customer": "cus_SWSlz3M7PoBOxv",
        //         "account_id": "accfsg5",
        //         "currency": "usd",
        //         "description": "Extended Pickup checkout"
        //     },
        //     "amount":"104",
        //     "site_id":"AS0987",
        //     "user_id":"56464",
        //     "days":"3"
        // }
        if (cardData == 'nocard') {
            setAlert('Please Choose a card!', 'error')
            setPaymentLoading(false)
        } else {
            setPaymentLoading(true)
            const getExtendedDate = (inv) => {
                const ext_date = Items.filter((item) => item.common_invoice == inv)
                const ext_date2 = addBusinessDays(
                    ext_date[0]?.schedule_location_id,
                    ext_date[0]?.sche_localpick_local,
                    Number(
                        global?.storeConfigration?.abandoned_schedule_hours?.value
                            ? global?.storeConfigration?.abandoned_schedule_hours?.value
                            : 0,
                    ) +
                        Number(global?.pluginConfiguration?.extended_pickup?.service_key) +
                        Number(user?.extended_pickup == 1 ? 5 : 0),
                )
                return ext_date2
            }

            const paymentBody = {
                invoice_id: extendInvoices.map((inv) => {
                    return {
                        id: inv,
                        amount: global?.pluginConfiguration?.extended_pickup?.access_key,
                        extended_date: moment.utc(getExtendedDate(inv)),
                    }
                }),

                payment_details: {
                    source: cardData,
                    account_id: process.env.REACT_APP_AUCTIONPAYID,
                    customer: user.card_paymentid,
                    currency: 'usd',
                    description: 'Extended Pickup checkout',
                },
                amount: parseFloat(
                    parseFloat(extendInvoices.length) *
                        parseFloat(global?.pluginConfiguration?.extended_pickup?.access_key),
                ).toFixed(2),
                site_id: global?.storeDetails?.site_id,
                user_id: user.id,
                days: global?.pluginConfiguration?.extended_pickup?.service_key,
            }
            await extendPickupPayment(paymentBody)
        }
    }

    useEffect(() => {
        if (Items.length && initial) {
            let temp_arr = []
            Items.map((val) => {
                if (val.sallertype) {
                    temp_arr.push(val.sallertype)
                }
            })
            if (temp_arr.length) getSimilarProductsQty({ id: temp_arr })
            setInitial(true)
        }
    }, [Items])
    useEffect(() => {
        if (similarQty?.length && initial) {
            let temp_pro = Items
            temp_pro.map((val) => {
                similarQty?.map((qty) => {
                    if (val.sallertype == qty.id) {
                        val.contact_seller = (
                            <Link to="/contact_us" target="_blank" rel="noopener noreferrer">
                                {qty.available_qty} Qty available. If you are still intrested,
                                Kindly contact seller.
                            </Link>
                        )
                    }
                })
            })
            setData([...temp_pro])
            console.log(temp_pro, 'temp_pro')
            setInitial(false)
        }
    }, [similarQty, Items])
    useEffect(() => {
        if (Items?.length) setSimilarQty(similar_products_qty)
    }, [similar_products_qty, Items])

    const retractBid = async (bid) => {
        // console.log('retractBid', bid)
        if (bid.mybidid && user?.id) {
            const formdata = new FormData()

            formdata.append('pid', bid.id)
            formdata.append('id', bid.mybidid)
            formdata.append('uid', user?.id)
            formdata.append('price', bid.mybid)
            formdata.append('auctionid', bid.auctionid)
            formdata.append('lotof', bid.lotof)
            formdata.append('is_buyer', true)
            // console.log('retractBid', formdata)
            const res = await axios.post(
                `${process.env.REACT_APP_BASE_URL}api_bidding/cancelbid_process`,
                formdata,
            )
            if (res.data.msg === 'yes') {
                getAllBuyerProducts(search)

                setAlert('Bid Retracted Successfully', 'success')
            } else {
                setAlert(res.data.msg, 'error')
            }
        }
    }

    useEffect(() => {
        if (global.storeConfigration?.ship_track_info?.value == 1 && props.page == 'bidwon') {
            getAllShippingAddress()
        }
    }, [])
    useEffect(() => {
        if (all_shipping_address.length) {
            setSelectAddress(all_shipping_address)
        }
    }, [all_shipping_address])
    useEffect(() => {
        if (global?.storeConfigration?.checkout_terms_and_condtions?.value == 1) {
            getStaticPage(
                {
                    page_id: 'checkout_terms_and_condtions',
                },
                1,
            )
        }
    }, [])
    useEffect(() => {
        if (global?.storeConfigration?.checkout_terms_and_condtions?.value == 1) {
            if (static_page.content) {
                setTermscondition(static_page.content)
            }
        }
    }, [static_page])

    const openshippingtracking = (data) => {
        selectAddress.map((val) => {
            if (parseInt(val.id) === parseInt(data.shipping_addr_id)) {
                setDisplayAddress({ ...val, ...data })
            }
        })
        setPopupopup(true)
    }

    const handleSearch = (event) => {
        event.preventDefault()
        setSearch({
            ...search,
            search: searchValue,
            page: 1,
        })
    }
    // useEffect(() => {
    //     console.log('99999999999999999999999999999999999999999999999999999999999', display_address)
    //     if (Object.keys(display_address).length > 0) {
    //         setPopupopup(true)
    //     }
    // }, [display_address])

    const redirect_checkout = () => {
        if (global.storeConfigration?.auction_dashboard_with_filter?.value) {
            localStorage.setItem('lotof', lotof)
        }
        if (global.pluginConfiguration?.shipping?.enable) {
            var check_hasshipping = 1,
                seller_zip = '',
                get_invoice_id = [],
                seller_zipcode = '',
                no_call_api = 1

            Items.map((data, index) => {
                if (invoiceId.includes(data.common_invoice) && parseInt(data.hasshipping)) {
                    if (data.custom_field_8) {
                        if (
                            seller_zipcode != JSON.parse(data.custom_field_8).zipcode &&
                            seller_zipcode != ''
                        ) {
                            no_call_api = 0
                        } else {
                            seller_zipcode = JSON.parse(data.custom_field_8).zipcode
                        }
                    }
                    check_hasshipping = 0
                    if (data.sell_zipcode != seller_zip && seller_zip != '') {
                        no_call_api = 0
                    } else {
                        seller_zip = data.sell_zipcode
                    }
                    if (
                        (data.weight != 0 &&
                            data.height != 0 &&
                            data.length != 0 &&
                            data.width != 0) ||
                        (data.custom_field_5 != '' &&
                            data.custom_field_6 != '' &&
                            data.custom_field_7 != '' &&
                            data.custom_field_8 != '')
                    ) {
                        get_invoice_id.push(data.common_invoice)
                    }
                }
            })
            if (check_hasshipping) {
                handleRedirectInternal(history, `checkout/auction?id=${invoiceId.join('&id=')}`)
            } else {
                if (no_call_api == 1) {
                    if (get_invoice_id.length > 0) {
                        check_get_shipping_rate_api({
                            invoiceID: get_invoice_id,
                            toPostalCode: user.zip,
                            fromPostalCode: seller_zip ? seller_zip : seller_zipcode,
                            toCountry: user.country,
                        })
                    } else {
                        handleRedirectInternal(
                            history,
                            `checkout/auction?id=${invoiceId.join('&id=')}`,
                        )
                    }
                } else {
                    setAlert(
                        'Your Selected Items Sellers Are Different.We are unable to update shippingcost.please select same sellers item and checkout',
                        'error',
                    )
                    return false
                }
            }
        } else {
            handleRedirectInternal(history, `checkout/auction?id=${invoiceId.join('&id=')}`)
        }
    }

    useEffect(() => {
        if (shipping_rate_calculation.status) {
            if (shipping_rate_calculation.status == 'success') {
                if (shipping_rate_calculation.data?.message?.shipping_error == '') {
                    handleRedirectInternal(history, `checkout/auction?id=${invoiceId.join('&id=')}`)
                } else {
                    if (shipping_rate_calculation.data?.message?.shipping_status == 500) {
                        setAlert(
                            'Product dimensional or Zip Code incorrect.Please check your Zip Code or contact seller.',
                            'error',
                        )
                    } else {
                        setAlert('Please Try Again Later!', 'error')
                    }
                }
            } else {
                setAlert('Please Try Again Later!', 'error')
            }
            clear_ship_station_amount()
        }
    }, [shipping_rate_calculation])
    const getBidText = (data) => {
        if (isAuthenticated && data.latestbid != null && user?.id != undefined) {
            if (data.auction) {
                if (
                    (data.highbid || data.highest_bidder_user_id == user?.id) &&
                    data.latestbid >= data.rprice
                ) {
                    if (data.market_status == 'open') {
                        return 'Winning'
                    } else if (data.market_status == 'sold') {
                        return 'Won'
                    }
                } else if (!data.highbid || data.highest_bidder_user_id != user?.id) {
                    if (data.market_status == 'open') {
                        return 'Outbid'
                    } else if (data.market_status == 'sold') {
                        return 'Lost'
                    }
                } else {
                    return ''
                }
            }
        }
    }
    function isScheduleAbandoned(item, user, addBusinessDays) {
        const abandonedHours = Number(
            global?.storeConfigration?.abandoned_schedule_hours?.value || 0,
        )

        const extendedPickupDays = Number(user?.extended_pickup == 1 ? 5 : 0)

        const resultDate = addBusinessDays(
            item?.schedule_location_id,
            item?.sche_localpick_local,
            abandonedHours + extendedPickupDays,
        )

        return resultDate.isBefore(moment(), 'day')
    }

    const makemarkasrecived = (data) => {
        var send_data = {
            invoice_id: data.common_invoice,
            site_id: global?.storeDetails?.site_id ? global.storeDetails.site_id : '',
        }
        markasrecived(send_data)
    }

    const sortbyauction = (event) => {
        setLotof(event.target.value)
        var send_data = search
        send_data.lotof = parseInt(event.target.value)

        getAllBuyerProducts(send_data)
    }
    const Component = () => (
        <div className="table-responsive otherInvoice">
            <table className="table table-borderlsss">
                <tbody>
                    {Items.filter(
                        (val) => !val.scheduled && val.common_invoice !== scheduleInvoiceId[0],
                    ).length !== 0 ? (
                        Items.filter(
                            (val) => !val.scheduled && val.location_id === scheduleLocationId,
                        ).map((item, index) => {
                            let include_invoice = true
                            if (global?.storeConfigration?.limit_pickup_days?.value) {
                                let startDate = moment(
                                    new Date(
                                        item.paid ? item.buynowpaid_date : item.date_closed,
                                    ).setHours(0, 0, 0, 0),
                                )
                                let endDate = startDate
                                    .clone()
                                    .add(
                                        parseInt(
                                            global?.storeConfigration?.limit_pickup_days?.value,
                                        ) - 1,
                                        'days',
                                    )
                                let selectedDate = moment(new Date(localSelectedDate))
                                const isInRange = selectedDate.isBetween(
                                    startDate,
                                    endDate,
                                    undefined,
                                    '[]',
                                )
                                if (!isInRange) {
                                    include_invoice = false
                                }
                                console.log(
                                    item.common_invoice,
                                    startDate.format('MM/DD/YYYY'),
                                    endDate.format('MM/DD/YYYY'),
                                    selectedDate.format('MM/DD/YYYY'),
                                    'endDate.isSameOrAfter(adjustedStartDate)',
                                    item.buynowpaid_date,
                                )
                            }
                            return (
                                <>
                                    {item &&
                                    item.common_invoice !== scheduleInvoiceId[0] &&
                                    include_invoice ? (
                                        <>
                                            <tr key={index}>
                                                <td style={{ width: '40px' }}>
                                                    <CheckBox
                                                        checked={scheduleInvoiceId.includes(
                                                            item.common_invoice,
                                                        )}
                                                        name="schedule"
                                                        label=""
                                                        onChange={(e) =>
                                                            handleScheduleInvoiceChange(
                                                                item.common_invoice,
                                                                item.location_id,
                                                            )
                                                        }
                                                        disabled={item.scheduled}
                                                    />
                                                </td>

                                                {/* <td>
                                                                ID: {item.lotof} -
                                                                {moment(item.date_added)
                                                                    .tz(moment.tz.guess())
                                                                    .format('MM/DD/YYYY')}
                                                                , {item.city},{item.state},
                                                                {item.zipcode}{' '}
                                                                {item.auctionlot_title}
                                                            </td> */}
                                                <td
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => {
                                                        if (showInvoice == item.common_invoice) {
                                                            setShowInvoice('')
                                                        } else {
                                                            setShowInvoice(item.common_invoice)
                                                        }
                                                    }}
                                                >
                                                    Invoice #{item.common_invoice}
                                                </td>
                                            </tr>
                                            {isVarifiedGfTheme
                                                ? null
                                                : buyer_allproducts_temp?.results
                                                      ?.filter(
                                                          (val) =>
                                                              val.common_invoice ==
                                                              item.common_invoice,
                                                      )
                                                      .map((val, index) => (
                                                          <tr
                                                              className={`show_${
                                                                  item.common_invoice
                                                              } ${
                                                                  showInvoice == item.common_invoice
                                                                      ? 'tableRow'
                                                                      : 'd-none'
                                                              }`}
                                                              key={index}
                                                          >
                                                              <td colSpan="2">
                                                                  <ol>
                                                                      <li>
                                                                          <Link
                                                                              to={`/product/${val.id}`}
                                                                              target="_blank"
                                                                              rel="noreferrer"
                                                                              className="aHref"
                                                                          >
                                                                              LOT #{val.lot_number}:{' '}
                                                                              {val.title}
                                                                          </Link>
                                                                      </li>
                                                                  </ol>
                                                              </td>
                                                          </tr>
                                                      ))}
                                        </>
                                    ) : null}
                                </>
                            )
                        })
                    ) : (
                        <NoRecordsFound />
                    )}
                </tbody>
            </table>
        </div>
    )

    useEffect(() => {
        if (params.get('loc')) {
            setSearch({
                ...search,
                warehouse_location: params.get('loc'),
            })
        }
        mountedRef.current = true
    }, [window.location.search])
    useEffect(() => {
        if (user) {
            socket.on('schedule_pickup_status', (data) => {
                if (data) {
                    let socket_data = data?.data.length ? data?.data[0] : {}
                    let tempItems = buyerAllProductsRef.current?.results
                    let socket_inv = tempItems.findIndex(
                        (val) => val.common_invoice == socket_data.invoice_id,
                    )
                    if (socket_inv) {
                        tempItems[socket_inv]['status'] = data.status
                    }
                    setData([...tempItems])
                }
                console.log(data, 'schedule_pickup_status+++das')
            })
        }

        return () => {
            socket.off('schedule_pickup_status', (data) => {
                return data
            })
        }
    }, [user])

    return (
        <>
            {props.gfTransaction && (
                <div className="row">
                    <div className="col-12 col-md-4 col-sm-6 form-group">
                        <form className="nav-standard-top-area-search">
                            <div className="nav-standard-top-area-search-inner trnsaction">
                                <input
                                    type="text"
                                    onChange={(e) => setSearchValue(e.target.value)}
                                    name="searchValue"
                                    value={searchValue}
                                    className="nav-standard-top-area-search-input open-sans onlyLotPlace"
                                    placeholder={'Search By Invoice'}
                                />
                                <button
                                    onClick={handleSearch}
                                    className="lin lin-magnifier subLotSearch nav-standard-top-area-search-sumbit onlyLotSearch"
                                    type={t('submit')}
                                >
                                    <span className="material-icons">search</span>
                                </button>
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-8 col-sm-6 ml-auto checkout-button form-group">
                        <div className="d-flex justify-content-end" style={{ gap: '5px' }}>
                            {global?.pluginConfiguration?.extended_pickup?.enable == 1 ? (
                                <PrimaryButton
                                    label={`Buy Extended Pickup (${extendInvoices.length})`}
                                    className="mbv-btn"
                                    btnSize="small"
                                    disabled={!extendInvoices.length}
                                    onClick={() => setOpenPickupExtension(true)}
                                />
                            ) : (
                                ''
                            )}
                            <SecondaryButton
                                label={
                                    props.gfTransaction
                                        ? `Checkout (${checkoutLength})`
                                        : `Cart (${checkoutLength})`
                                }
                                className="mbv-btn"
                                btnSize="small checkoutbutton"
                                onClick={() => redirect_checkout()}
                                disabled={!checkoutLength}
                                iconLeft={props.gfTransaction ? '' : <ShoppingCart />}
                            />
                        </div>
                    </div>
                </div>
            )}
            <div className="row mb-3">
                {!props.gfTransaction && (
                    <div className="col-12 col-md-2 col-sm-6 form-group">
                        <form className="nav-standard-top-area-search">
                            <div className="nav-standard-top-area-search-inner">
                                <input
                                    type="text"
                                    onChange={(e) => setSearchValue(e.target.value)}
                                    name="searchValue"
                                    value={searchValue}
                                    className="nav-standard-top-area-search-input open-sans onlyLotPlace"
                                    placeholder={'ID/Title'}
                                />
                                <button
                                    onClick={handleSearch}
                                    className="lin lin-magnifier subLotSearch nav-standard-top-area-search-sumbit onlyLotSearch"
                                    type={t('submit')}
                                >
                                    <span className="material-icons">search</span>
                                </button>
                            </div>
                        </form>
                    </div>
                )}

                {global?.storeConfigration?.new_schedule_pickup?.value == 1 &&
                (props.page === 'bidwon' || props.page === 'buynow') ? (
                    scheduleLength ? (
                        <div className="col-12 col-md-5 col-sm-6 ml-auto schedule-pickup-btn d-none form-group">
                            <MultiPickup
                                invoice={{
                                    site_id: global?.storeDetails?.site_id,
                                    common_invoice: scheduleInvoiceId,
                                    date_closed: date_closed,
                                    paid_date: paid_date,
                                }}
                                pickupData={{}}
                                auctionData={{
                                    location_id: Items.find(
                                        (val) => val.common_invoice === scheduleInvoiceId[0],
                                    )?.location_id,
                                }}
                                sellerData={{
                                    seller_name: global?.storeDetails?.name,
                                    email: global?.storeDetails?.contact_email,
                                }}
                                trigger={trigger}
                                setTrigger={setTrigger}
                                sch_type={props.sch_type}
                                openSchedule={openSchedule}
                                multipleInvoice={1}
                                component={<Component />}
                                clearData={() => {
                                    setScheduleInvoiceId([])
                                    setOpenSchedule(false)
                                }}
                                location_id={search.warehouse_location || locationList[0]?.id}
                                setLocalSelectedDate={setLocalSelectedDate}
                                setTimingsInv={setTimingsInv}
                                timingsInv={timingsInv}
                            />
                            {/* <MultiPickup
                                invoice={{
                                    site_id: global?.storeDetails?.site_id,
                                    id: scheduleInvoiceId,
                                    schedule_location_id: Items.find(
                                        (val) => val.scheduled === scheduleInvoiceId[0],
                                    )?.schedule_location_id,
                                    common_invoice: Items.filter(
                                        (val) => val.scheduled === scheduleInvoiceId[0],
                                    ).map((val) => val.common_invoice),
                                    date_closed: date_closed,
                                    paid_date: paid_date,
                                }}
                                pickupData={{}}
                                auctionData={{
                                    location_id: Items.find(
                                        (val) => val.scheduled === scheduleInvoiceId[0],
                                    )?.location_id,
                                }}
                                sellerData={{
                                    seller_name: global?.storeDetails?.name,
                                    email: global?.storeDetails?.contact_email,
                                }}
                                trigger={trigger}
                                setTrigger={setTrigger}
                                sch_type={props.sch_type}
                            /> */}
                        </div>
                    ) : null
                ) : null}
                <div className="col-md-2 col-sm-4 auctionTit form-group">
                    <CustomSelect
                        label="Location"
                        value={search.warehouse_location}
                        size="small"
                        selectType="noBorder"
                        name="location"
                        onChange={(event, editor) => {
                            if (primeBidsTheme) {
                                handleRedirectInternal(
                                    history,
                                    `dashboard/purchase-history?loc=${event.target.value}`,
                                )
                            } else {
                                handleRedirectInternal(
                                    history,
                                    `dashboard/transactions?loc=${event.target.value}`,
                                )
                            }
                        }}
                    >
                        {global.storeDetails?.theme == 19 || primeBidsTheme ? (
                            <option value="1">All</option>
                        ) : (
                            ''
                        )}
                        {locationList.map((opt, optindex) => (
                            <option value={opt.id}>{opt.location_name}</option>
                        ))}
                    </CustomSelect>
                </div>
                {!props.gfTransaction ? (
                    <div className="col-md-2 col-sm-4 auctionTit form-group">
                        <CustomSelect
                            label="Auction Title"
                            value={lotof}
                            size="small"
                            selectType="noBorder"
                            name="lotof"
                            onChange={(event, editor) => sortbyauction(event)}
                        >
                            <option value={''}>All Auctions</option>
                            {auction_list.map((opt, optindex) => (
                                <option value={opt.id}>{opt.title}</option>
                            ))}
                        </CustomSelect>
                    </div>
                ) : (
                    ''
                )}
                <div className="col-md-2 col-sm-4 auctionTit form-group">
                    <CustomSelect
                        label={props.gfTransaction ? 'Status' : 'Paid Status'}
                        value={search.paid}
                        size="small"
                        selectType="noBorder"
                        name="paid"
                        onChange={(event, editor) =>
                            setSearch({
                                ...search,
                                paid: event.target.value,
                            })
                        }
                    >
                        <option value={'all'}>All</option>
                        <option value={'paid'}>Paid</option>
                        <option value={'unpaid'}>Unpaid</option>
                    </CustomSelect>
                </div>
                <div className="col-md-2 col-sm-4 auctionTit form-group">
                    {isVarifiedGfTheme && !isBargainsProject ? (
                        <CustomSelect
                            label="Pickup Status"
                            value={search.sch_status}
                            size="small"
                            selectType="noBorder"
                            name="paid"
                            onChange={(event, editor) =>
                                setSearch({
                                    ...search,
                                    sch_status: event.target.value,
                                })
                            }
                        >
                            <option value={'all'}>All</option>
                            <option value={'ready'}>Ready for pickup</option>
                            <option value={'abandoned'}>Abandoned</option>
                            <option value={'completed'}>Completed</option>
                        </CustomSelect>
                    ) : (
                        <CustomSelect
                            label="Schedule Status"
                            value={search.sch_type}
                            size="small"
                            selectType="noBorder"
                            name="schedule"
                            onChange={(event, editor) =>
                                setSearch({
                                    ...search,
                                    sch_type: event.target.value,
                                })
                            }
                        >
                            <option value={''}>All</option>
                            <option value={'1'}>Un Scheduled</option>
                            <option value={'2'}>Scheduled</option>
                            <option value={'4'}>Completed</option>
                        </CustomSelect>
                    )}
                </div>
            </div>

            {loading ? (
                <div className="text-center">
                    <Loader />
                </div>
            ) : Items?.length > 0 ? (
                <>
                    <div className="table-responsive">
                        {!props.gridView && (
                            <table className="table table-hover mobile-table responisveTable">
                                <thead className="hidden-mobile">
                                    <tr>
                                        {global.pluginConfiguration?.extended_pickup?.enable ==
                                        1 ? (
                                            <th className="tableHeadd">
                                                <CheckBox
                                                    checked={(() => {
                                                        const allowedExtension = Items.filter(
                                                            (item) =>
                                                                item.status == 'ready' &&
                                                                item.extened_pickup_day == 0 &&
                                                                !isScheduleAbandoned(
                                                                    item,
                                                                    user,
                                                                    addBusinessDays,
                                                                ),
                                                        )

                                                        return (
                                                            allowedExtension.length > 0 &&
                                                            allowedExtension.length ===
                                                                extendInvoices.length
                                                        )
                                                    })()}
                                                    name={`selectall_extend`}
                                                    label={``}
                                                    onChange={(e) => {
                                                        const allowedExtension = Items.filter(
                                                            (item) =>
                                                                item.status == 'ready' &&
                                                                item.extened_pickup_day == 0 &&
                                                                !isScheduleAbandoned(
                                                                    item,
                                                                    user,
                                                                    addBusinessDays,
                                                                ),
                                                        )
                                                        if (
                                                            allowedExtension.length > 0 &&
                                                            allowedExtension.length ===
                                                                extendInvoices.length
                                                        ) {
                                                            setExtendInvoices([])
                                                        } else {
                                                            setExtendInvoices(
                                                                allowedExtension.map(
                                                                    (item) => item.common_invoice,
                                                                ),
                                                            )
                                                        }
                                                    }}
                                                />
                                            </th>
                                        ) : (
                                            ''
                                        )}
                                        <th className="numCell" role="id">
                                            {props.gfTransaction ? 'Invoice #' : 'ID'}
                                        </th>
                                        {props.gfTransaction ? (
                                            ''
                                        ) : (
                                            <th role="Title"> {'Title'}</th>
                                        )}
                                        <th role="Items">
                                            {props.gfTransaction ? 'Item Qty' : '# Items'}
                                        </th>
                                        <th role="Total">Total</th>
                                        {props.gfTransaction ? (
                                            ''
                                        ) : (
                                            <th role="Balance Due">Balance Due</th>
                                        )}
                                        <th role="Status">Status</th>
                                        <th role="Pickup Appointment">
                                            {props.gfTransaction
                                                ? 'Last Day To Pick Up'
                                                : 'Pickup Appointment'}
                                        </th>
                                        {global.storeDetails?.theme == 19 &&
                                        global?.pluginConfiguration?.refund?.enable == 1 &&
                                        global.storeConfigration?.enable_request_refund?.value ==
                                            1 &&
                                        !isVarifiedGfTheme ? (
                                            <th
                                                role="Pickup Appointment"
                                                className={`${
                                                    props.gfTransaction ? 'text-center' : ''
                                                }`}
                                            >
                                                Refund
                                            </th>
                                        ) : null}
                                        <th
                                            role="Actions"
                                            className={`${
                                                props.gfTransaction ? 'text-center' : ''
                                            }`}
                                        >
                                            {props.gfTransaction ? 'Invoice' : 'Actions'}
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {Items.length !== 0 &&
                                        Items.map((item, index) => {
                                            return (
                                                <>
                                                    {item ? (
                                                        <tr key={index}>
                                                            {global.pluginConfiguration
                                                                ?.extended_pickup?.enable == 1 ? (
                                                                <td data-label="">
                                                                    <CheckBox
                                                                        checked={extendInvoices.includes(
                                                                            item.common_invoice,
                                                                        )}
                                                                        name="extend-check"
                                                                        label=""
                                                                        disabled={
                                                                            item?.status !==
                                                                                'ready' ||
                                                                            item?.extened_pickup_day >
                                                                                0 ||
                                                                            isScheduleAbandoned(
                                                                                item,
                                                                                user,
                                                                                addBusinessDays,
                                                                            )
                                                                                ? true
                                                                                : false
                                                                        }
                                                                        onChange={(e) =>
                                                                            handleExtendPickup(
                                                                                item,
                                                                                true,
                                                                            )
                                                                        }
                                                                    />
                                                                </td>
                                                            ) : null}
                                                            <td data-label="Invoice #">
                                                                {props.gfTransaction ? (
                                                                    <div
                                                                        className="navLinkColor"
                                                                        onClick={() => {
                                                                            if (
                                                                                global
                                                                                    .storeConfigration
                                                                                    ?.auction_dashboard_with_filter
                                                                                    ?.value
                                                                            ) {
                                                                                localStorage.setItem(
                                                                                    'lotof',
                                                                                    lotof,
                                                                                )
                                                                            }
                                                                            handleRedirectInternal(
                                                                                history,
                                                                                item.buynow == 1
                                                                                    ? `invoice/buynow?id=${item.common_invoice}`
                                                                                    : `invoice/auction?id=${item.common_invoice}`,
                                                                            )
                                                                        }}
                                                                    >
                                                                        {item.common_invoice}
                                                                    </div>
                                                                ) : (
                                                                    item.common_invoice
                                                                )}
                                                            </td>
                                                            {/* <td>
                                                                ID: {item.lotof} -
                                                                {moment(item.date_added)
                                                                    .tz(moment.tz.guess())
                                                                    .format('MM/DD/YYYY')}
                                                                , {item.city},{item.state},
                                                                {item.zipcode}{' '}
                                                                {item.auctionlot_title}
                                                            </td> */}
                                                            {props.gfTransaction ? (
                                                                ''
                                                            ) : (
                                                                <td data-label="Title">
                                                                    {item.auctionlot_title}
                                                                </td>
                                                            )}
                                                            <td data-label="Item Qty">
                                                                {isVarifiedGfTheme || primeBidsTheme
                                                                    ? item?.overall_qty
                                                                    : item.total_lots_count}
                                                            </td>
                                                            <td
                                                                data-label="Total"
                                                                className="amount "
                                                            >
                                                                {item.paid
                                                                    ? currencyFormat(
                                                                          parseFloat(
                                                                              item.total_invoice,
                                                                          ),
                                                                          props.currency,
                                                                      )
                                                                    : props.gfTransaction
                                                                    ? currencyFormat(
                                                                          parseFloat(
                                                                              item.total_wprice,
                                                                          ) +
                                                                              (parseFloat(
                                                                                  item.total_wprice,
                                                                              ) *
                                                                                  parseFloat(
                                                                                      item.buyerpremium_percentage,
                                                                                  )) /
                                                                                  100 +
                                                                              ((parseFloat(
                                                                                  item.total_wprice,
                                                                              ) +
                                                                                  (parseFloat(
                                                                                      item.total_wprice,
                                                                                  ) *
                                                                                      parseFloat(
                                                                                          item.buyerpremium_percentage,
                                                                                      )) /
                                                                                      100 +
                                                                                  parseFloat(
                                                                                      item.lot_fee ||
                                                                                          0,
                                                                                  ) *
                                                                                      parseInt(
                                                                                          item.total_lots_count,
                                                                                      )) *
                                                                                  parseFloat(
                                                                                      user?.tax_excempt ==
                                                                                          1
                                                                                          ? 0
                                                                                          : global
                                                                                                ?.storeConfigration
                                                                                                ?.sales_tax
                                                                                                ?.value,
                                                                                  )) /
                                                                                  100 +
                                                                              parseFloat(
                                                                                  item.lot_fee || 0,
                                                                              ) *
                                                                                  parseInt(
                                                                                      item.total_lots_count,
                                                                                  ),
                                                                          props.currency,
                                                                      )
                                                                    : currencyFormat(
                                                                          parseFloat(
                                                                              item.total_wprice,
                                                                          ) +
                                                                              (parseFloat(
                                                                                  item.total_wprice,
                                                                              ) *
                                                                                  parseFloat(
                                                                                      item.buyerpremium_percentage,
                                                                                  )) /
                                                                                  100 +
                                                                              ((parseFloat(
                                                                                  item.total_wprice,
                                                                              ) +
                                                                                  (parseFloat(
                                                                                      item.total_wprice,
                                                                                  ) *
                                                                                      parseFloat(
                                                                                          item.buyerpremium_percentage,
                                                                                      )) /
                                                                                      100 +
                                                                                  parseFloat(
                                                                                      global
                                                                                          ?.storeConfigration
                                                                                          ?.line_item_fee
                                                                                          ?.value ||
                                                                                          0,
                                                                                  ) *
                                                                                      parseInt(
                                                                                          item.total_lots_count,
                                                                                      )) *
                                                                                  parseFloat(
                                                                                      user?.tax_excempt ==
                                                                                          1
                                                                                          ? 0
                                                                                          : global
                                                                                                ?.storeConfigration
                                                                                                ?.sales_tax
                                                                                                ?.value,
                                                                                  )) /
                                                                                  100 +
                                                                              parseFloat(
                                                                                  global
                                                                                      ?.storeConfigration
                                                                                      ?.line_item_fee
                                                                                      ?.value || 0,
                                                                              ) *
                                                                                  parseInt(
                                                                                      item.total_lots_count,
                                                                                  ),
                                                                          props.currency,
                                                                      )}
                                                            </td>
                                                            {props.gfTransaction ? (
                                                                ''
                                                            ) : (
                                                                <td
                                                                    data-label="Balance Due"
                                                                    className="amount "
                                                                >
                                                                    {item.paid
                                                                        ? currencyFormat(
                                                                              0,
                                                                              props.currency,
                                                                          )
                                                                        : currencyFormat(
                                                                              parseFloat(
                                                                                  item.total_wprice,
                                                                              ) +
                                                                                  (parseFloat(
                                                                                      item.total_wprice,
                                                                                  ) *
                                                                                      parseFloat(
                                                                                          item.buyerpremium_percentage,
                                                                                      )) /
                                                                                      100 +
                                                                                  ((parseFloat(
                                                                                      item.total_wprice,
                                                                                  ) +
                                                                                      (parseFloat(
                                                                                          item.total_wprice,
                                                                                      ) *
                                                                                          parseFloat(
                                                                                              item.buyerpremium_percentage,
                                                                                          )) /
                                                                                          100 +
                                                                                      parseFloat(
                                                                                          global
                                                                                              ?.storeConfigration
                                                                                              ?.line_item_fee
                                                                                              ?.value ||
                                                                                              0,
                                                                                      ) *
                                                                                          parseInt(
                                                                                              item.total_lots_count,
                                                                                          )) *
                                                                                      parseFloat(
                                                                                          user?.tax_excempt ==
                                                                                              1
                                                                                              ? 0
                                                                                              : global
                                                                                                    ?.storeConfigration
                                                                                                    ?.sales_tax
                                                                                                    ?.value,
                                                                                      )) /
                                                                                      100 +
                                                                                  parseFloat(
                                                                                      global
                                                                                          ?.storeConfigration
                                                                                          ?.line_item_fee
                                                                                          ?.value ||
                                                                                          0,
                                                                                  ) *
                                                                                      parseInt(
                                                                                          item.total_lots_count,
                                                                                      ),
                                                                              props.currency,
                                                                          )}
                                                                </td>
                                                            )}
                                                            <td
                                                                data-label="Status"
                                                                className={
                                                                    isLOAProject
                                                                        ? parseInt(
                                                                              item.buynowpaid,
                                                                          ) == 0
                                                                            ? 'clr-status-red'
                                                                            : 'clr-status-green'
                                                                        : ''
                                                                }
                                                            >
                                                                <strong>
                                                                    {parseInt(item.buynowpaid) == 0
                                                                        ? 'Unpaid'
                                                                        : 'Paid'}
                                                                </strong>
                                                            </td>
                                                            <td
                                                                data-label="Last Day To Pick Up"
                                                                className="pickUpAppont"
                                                            >
                                                                {item.scheduled ? (
                                                                    item.status === 'completed' ? (
                                                                        <>
                                                                            <strong>
                                                                                Completed
                                                                            </strong>{' '}
                                                                            on{' '}
                                                                            {moment
                                                                                .utc(
                                                                                    item?.sche_completed_date,
                                                                                )
                                                                                .local()
                                                                                .format(
                                                                                    isVarifiedGfTheme
                                                                                        ? 'dddd, MMMM DD'
                                                                                        : 'dddd, MMMM DD [at] h:mm A',
                                                                                )}
                                                                        </>
                                                                    ) : item.status ===
                                                                      'booking' ? (
                                                                        <>
                                                                            <strong>Booked</strong>{' '}
                                                                            on{' '}
                                                                            {moment
                                                                                .utc(
                                                                                    item?.sche_localpick_local,
                                                                                )
                                                                                .local()
                                                                                .format(
                                                                                    isVarifiedGfTheme
                                                                                        ? 'dddd, MMMM DD'
                                                                                        : 'dddd, MMMM DD [at] h:mm A',
                                                                                )}
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            {isVarifiedGfTheme
                                                                                ? ' '
                                                                                : 'Scheduled on '}
                                                                            {item.extened_pickup_day >
                                                                            0
                                                                                ? addBusinessDays(
                                                                                      item?.schedule_location_id,
                                                                                      item?.sche_localpick_local,
                                                                                      Number(
                                                                                          global
                                                                                              ?.storeConfigration
                                                                                              ?.abandoned_schedule_hours
                                                                                              ?.value
                                                                                              ? global
                                                                                                    ?.storeConfigration
                                                                                                    ?.abandoned_schedule_hours
                                                                                                    ?.value
                                                                                              : 0,
                                                                                      ) +
                                                                                          Number(
                                                                                              global
                                                                                                  ?.pluginConfiguration
                                                                                                  ?.extended_pickup
                                                                                                  ?.service_key,
                                                                                          ) +
                                                                                          Number(
                                                                                              user?.extended_pickup ==
                                                                                                  1
                                                                                                  ? 5
                                                                                                  : 0,
                                                                                          ),
                                                                                  ).format(
                                                                                      isVarifiedGfTheme
                                                                                          ? 'dddd, MMMM DD'
                                                                                          : 'dddd, MMMM DD [at] h:mm A',
                                                                                  )
                                                                                : props.gfTransaction &&
                                                                                  !isBuyBestProject
                                                                                ? addBusinessDays(
                                                                                      item?.schedule_location_id,
                                                                                      item?.sche_localpick_local,
                                                                                      Number(
                                                                                          global
                                                                                              ?.storeConfigration
                                                                                              ?.abandoned_schedule_hours
                                                                                              ?.value
                                                                                              ? global
                                                                                                    ?.storeConfigration
                                                                                                    ?.abandoned_schedule_hours
                                                                                                    ?.value
                                                                                              : 0,
                                                                                      ) +
                                                                                          Number(
                                                                                              user?.extended_pickup ==
                                                                                                  1
                                                                                                  ? 5
                                                                                                  : 0,
                                                                                          ),
                                                                                  ).format(
                                                                                      isVarifiedGfTheme
                                                                                          ? 'dddd, MMMM DD'
                                                                                          : 'dddd, MMMM DD [at] h:mm A',
                                                                                  )
                                                                                : moment
                                                                                      .utc(
                                                                                          item?.sche_localpick_local,
                                                                                      )
                                                                                      .local()
                                                                                      .format(
                                                                                          isVarifiedGfTheme
                                                                                              ? 'dddd, MMMM DD'
                                                                                              : 'dddd, MMMM DD [at] h:mm A',
                                                                                      )}
                                                                            <p className="text-capitalize">
                                                                                <strong>
                                                                                    {item.status ===
                                                                                    'handover'
                                                                                        ? 'Run Order'
                                                                                        : item.status}
                                                                                </strong>
                                                                            </p>
                                                                        </>
                                                                    )
                                                                ) : isVarifiedGfTheme ||
                                                                  primeBidsTheme ? (
                                                                    '-'
                                                                ) : (
                                                                    <PrimaryButton
                                                                        label={
                                                                            isVarifiedGfTheme ||
                                                                            primeBidsTheme
                                                                                ? 'Pickup Appointment'
                                                                                : 'Schedule Pickup Appointment'
                                                                        }
                                                                        className="w-auto"
                                                                        onClick={() => {
                                                                            handleScheduleInvoiceChange(
                                                                                item.common_invoice,
                                                                                item.location_id,
                                                                            )
                                                                            setOpenSchedule(true)
                                                                        }}
                                                                        disabled={item.scheduled}
                                                                    />
                                                                )}
                                                                {/* <CheckBox
                                                                    checked={scheduleInvoiceId.includes(
                                                                        item.common_invoice,
                                                                    )}
                                                                    name="schedule"
                                                                    label=""
                                                                    onChange={(e) =>
                                                                        handleScheduleInvoiceChange(
                                                                            item.common_invoice,
                                                                            item.location_id,
                                                                        )
                                                                    }
                                                                    disabled={item.scheduled}
                                                                /> */}
                                                                {(isVarifiedGfTheme ||
                                                                    primeBidsTheme) &&
                                                                global?.pluginConfiguration
                                                                    ?.extended_pickup?.enable ==
                                                                    1 &&
                                                                item.status == 'ready' ? (
                                                                    item.extened_pickup_day > 0 ? (
                                                                        <span className="text-danger">
                                                                            Pickup Extended
                                                                        </span>
                                                                    ) : (
                                                                        ''
                                                                        // <PrimaryButton
                                                                        //     label={'Extend Pickup'}
                                                                        //     className="w-auto"
                                                                        //     onClick={() => {
                                                                        //         handleExtendPickup(
                                                                        //             item,
                                                                        //         )
                                                                        //     }}
                                                                        // />
                                                                    )
                                                                ) : (
                                                                    ''
                                                                )}
                                                            </td>
                                                            {global.storeDetails?.theme == 19 &&
                                                            global?.pluginConfiguration?.refund
                                                                ?.enable == 1 &&
                                                            global.storeConfigration
                                                                ?.enable_request_refund?.value ==
                                                                1 &&
                                                            !isVarifiedGfTheme ? (
                                                                <td
                                                                    className={`${
                                                                        props.gfTransaction
                                                                            ? 'text-center'
                                                                            : ''
                                                                    }`}
                                                                >
                                                                    {item.paid !== 0 ? (
                                                                        <Requestplugin
                                                                            lot_id={item.id}
                                                                            invoice_id={
                                                                                item.common_invoice
                                                                            }
                                                                            trigger={refundTrigger}
                                                                            setTrigger={
                                                                                setRefundTrigger
                                                                            }
                                                                            seller_refund_accept={
                                                                                item.seller_refund_accept
                                                                            }
                                                                            refund_request_notes={
                                                                                item.refund_request_notes
                                                                            }
                                                                            warrantlyList={
                                                                                warrantlyList
                                                                            }
                                                                            gfTransaction={
                                                                                props.gfTransaction
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        '-'
                                                                    )}
                                                                </td>
                                                            ) : null}
                                                            <td
                                                                data-label="Actions"
                                                                className="text-right"
                                                            >
                                                                {item.buynowpaid ? (
                                                                    <div className="secButton">
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-link text-black box-shadow-unset"
                                                                            style={{
                                                                                boxShadow: 'unset',
                                                                            }}
                                                                            onClick={() => {
                                                                                if (
                                                                                    global
                                                                                        .storeConfigration
                                                                                        ?.auction_dashboard_with_filter
                                                                                        ?.value
                                                                                ) {
                                                                                    localStorage.setItem(
                                                                                        'lotof',
                                                                                        lotof,
                                                                                    )
                                                                                }
                                                                                handleRedirectInternal(
                                                                                    history,
                                                                                    item.buynow == 1
                                                                                        ? `invoice/buynow?id=${item.common_invoice}`
                                                                                        : `invoice/auction?id=${item.common_invoice}`,
                                                                                )
                                                                            }}
                                                                        >
                                                                            View
                                                                        </button>
                                                                    </div>
                                                                ) : (
                                                                    <div
                                                                        className="d-flex align-items-center justify-content-end"
                                                                        style={{ gap: '10px' }}
                                                                    >
                                                                        {isVarifiedGfTheme &&
                                                                        global.storeConfigration
                                                                            ?.auctionio_auto_payment_seller
                                                                            ?.value == 1 ? (
                                                                            item.autopay > 0 ||
                                                                            item.autopay_err_check >
                                                                                0 ? (
                                                                                <div className="primButton">
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-link text-black"
                                                                                        style={{
                                                                                            boxShadow:
                                                                                                'unset',
                                                                                            whiteSpace:
                                                                                                'nowrap',
                                                                                        }}
                                                                                        onClick={() =>
                                                                                            handleInvoiceChange(
                                                                                                item.common_invoice,
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        {invoiceId.includes(
                                                                                            item.common_invoice,
                                                                                        )
                                                                                            ? 'Remove From Cart'
                                                                                            : 'Add To Cart'}
                                                                                    </button>
                                                                                </div>
                                                                            ) : null
                                                                        ) : (
                                                                            <div className="primButton">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-link text-black"
                                                                                    style={{
                                                                                        boxShadow:
                                                                                            'unset',
                                                                                        whiteSpace:
                                                                                            'nowrap',
                                                                                    }}
                                                                                    onClick={() =>
                                                                                        handleInvoiceChange(
                                                                                            item.common_invoice,
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    {invoiceId.includes(
                                                                                        item.common_invoice,
                                                                                    )
                                                                                        ? 'Remove From Cart'
                                                                                        : 'Add To Cart'}
                                                                                </button>
                                                                            </div>
                                                                        )}

                                                                        <div className="secButton">
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-link text-black"
                                                                                style={{
                                                                                    boxShadow:
                                                                                        'unset',
                                                                                }}
                                                                                onClick={() => {
                                                                                    if (
                                                                                        global
                                                                                            .storeConfigration
                                                                                            ?.auction_dashboard_with_filter
                                                                                            ?.value
                                                                                    ) {
                                                                                        localStorage.setItem(
                                                                                            'lotof',
                                                                                            lotof,
                                                                                        )
                                                                                    }
                                                                                    handleRedirectInternal(
                                                                                        history,
                                                                                        `invoice/auction?id=${item.common_invoice}`,
                                                                                    )
                                                                                }}
                                                                            >
                                                                                View
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ) : null}
                                                </>
                                            )
                                        })}
                                </tbody>
                            </table>
                        )}
                        {props.gridView && Items.length !== 0 && (
                            <div
                                className="table-responsive lineItemBidTable mt-2 sublots-table mySubmitTable"
                                id="sublot"
                            >
                                <LotListProduct
                                    listview={false}
                                    searchResult={Items}
                                    className="liquidationBuyCard"
                                    cardType={'grid'}
                                    hideQuickBid={global.storeDetails?.theme == 19 ? true : false}
                                />
                            </div>
                        )}
                    </div>
                    {props.abandoned ? (
                        <Pagination
                            count={Math.ceil(abandonedOrders.totaProducts / 10)}
                            page={abandonedOrders.page}
                            onChange={onHandlePage}
                        />
                    ) : (
                        <Pagination
                            count={Math.ceil(totalItems / search.sh_limit)}
                            page={search.page}
                            onChange={onHandlePage}
                        />
                    )}
                </>
            ) : (
                <NoRecordsFound />
            )}

            {props.sliderTheme == 'multiseller' ? (
                <MultisellerSlider
                    storeTheme={props.storeTheme}
                    selectedLot={selectedProduct}
                    handleClose={handleClose}
                    currency={props.currency}
                    sliderTheme={props.sliderTheme}
                    itemDetails={Items}
                    from={'card'}
                    getAllProducts={(e) => {
                        return true
                    }}
                />
            ) : (
                <SlidePanel
                    type="right"
                    selectedLot={selectedProduct}
                    temDetails={Items}
                    handleClose={handleClose}
                    from={'card'}
                    getAllProducts={() => {
                        return true
                    }}
                />
            )}

            <Popup
                open={popup_open}
                handleClose={(e) => setPopupopup(false)}
                size="md"
                className="save-search-modal"
                modaltitle="Shipping Info"
            >
                {Object.keys(display_address).length > 0 ? (
                    <>
                        <div className="row">
                            <div className="col-6">
                                <b>{'Shipping User Info: '}</b>
                                {display_address.first_name + ' ' + display_address.last_name}
                            </div>
                            <div className="col-6">
                                <b>{'Shipping Address: '}</b>
                                {display_address.address}
                            </div>
                        </div>
                        <br></br>
                        <div className="row">
                            <div className="col-6">
                                <b>{'Email: '}</b>
                                {display_address.email}
                            </div>
                            <div className="col-6">
                                <b>{'Tracking Number: '}</b>
                                {display_address.tracking_number
                                    ? display_address.tracking_number
                                    : '-'}
                            </div>
                        </div>
                        <br></br>
                        <div className="row">
                            <div className="col-6">
                                <b>{'Phone: '}</b>
                                {display_address.phone}
                            </div>
                        </div>
                        <br></br>
                        <div className="row">
                            <div className="col-6">
                                <b>{'Tracking Service: '}</b>
                                {global.pluginConfiguration?.shipping?.service_key
                                    ? global.pluginConfiguration.shipping.service_key
                                    : '-'}
                            </div>
                        </div>
                        <br></br>
                        <div className="row">
                            <div className="col-6">
                                <b>{'Tracking Info: '}</b>
                                {display_address.localpickup ? 'Local-Pick-Up' : 'Shipping'}
                            </div>
                        </div>
                        <br></br>
                        <div className="actionWrapper">
                            <div className="row">
                                <div className="col-3">
                                    {' '}
                                    <PrimaryButton
                                        label={`Close`}
                                        className="mbv-btn"
                                        onClick={(e) => setPopupopup(false)}
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <>Loading...</>
                )}
            </Popup>
            <Popup
                open={feedbackOpen}
                handleClose={(e) => setFeedbackOpen(false)}
                size="md"
                className="save-search-modal"
                modaltitle="Feedback"
            >
                <AddFeedback
                    item={feedbackItem}
                    closePopup={() => setFeedbackOpen(false)}
                    clearSelectedItem={() => setFeedbackItem({})}
                />
            </Popup>
            <Popup
                open={additionalPayOpen}
                handleClose={(e) => setAdditionalPayOpen(false)}
                size="md"
                className="save-search-modal"
                modaltitle="Additional Pay"
            >
                <AdditionalPayment
                    item={additionalPayItem}
                    closePopup={() => setAdditionalPayOpen(false)}
                    clearSelectedItem={() => setAdditionalPayItem({})}
                    trigger={refundTrigger}
                    setTrigger={setRefundTrigger}
                />
            </Popup>
            <CustomDialog
                open={popupchecked}
                function={() => setPopupchecked(false)}
                size="md"
                className="save-search-modal"
                title="Terms and Conditions"
                closeBtn={true}
            >
                <div
                    dangerouslySetInnerHTML={{
                        __html: `${global?.storeDetails?.terms_condition}${termscondtions}<p><b>Terms and conditions accepted by the ${user?.first_name} ${user?.last_name}.</b</p>`,
                    }}
                ></div>
            </CustomDialog>
            <Popup
                open={messageChecked}
                handleClose={() => {
                    setMessageChecked(false)
                    setBuynowId({})
                }}
                size="md"
                className="save-search-modal"
                modaltitle="Upload Files"
            >
                <InvoiceMessage
                    project_id={buynowId?.common_invoice}
                    chatUser={{
                        first_name: `${buynowId?.title} -`,
                        last_name: ` ${buynowId?.common_invoice}`,
                        id: buynowId?.user_id,
                    }}
                    hide_header={1}
                    hide_message_box={1}
                />
            </Popup>
            <Popup
                open={openPickupExtension}
                handleClose={() => {
                    !paymentLoading && setOpenPickupExtension(false)
                }}
                modalClass="pickUpExten"
                className="save-search-modal"
                modaltitle="Extended Pickup"
            >
                {
                    <>
                        <div className="extendCardGird">
                            <div className="topInfoSec">
                                <div>
                                    <h6>
                                        Invoice{' '}
                                        <span>
                                            :{' '}
                                            {Items.filter((item) =>
                                                extendInvoices.includes(item.common_invoice),
                                            )
                                                .map((item) => item.common_invoice)
                                                .join(', ')}
                                        </span>
                                    </h6>
                                    <h6>
                                        Amount{' (per invoice)'}
                                        <span>
                                            :{' '}
                                            {currencyFormat(
                                                parseFloat(
                                                    global?.pluginConfiguration?.extended_pickup
                                                        ?.access_key,
                                                ),
                                                props.currency,
                                            )}
                                        </span>
                                    </h6>
                                </div>

                                <h6>
                                    Total Amount{' '}
                                    <span>
                                        :{' '}
                                        {currencyFormat(
                                            parseFloat(
                                                extendInvoices.length *
                                                    parseFloat(
                                                        global?.pluginConfiguration?.extended_pickup
                                                            ?.access_key,
                                                    ),
                                            ).toFixed(2),
                                            props.currency,
                                        )}
                                    </span>
                                </h6>
                            </div>
                            <div className="cardSecton">
                                {allData &&
                                    allData.map((data, index) => (
                                        <div key={index} className="cardSelect 1233">
                                            <label htmlFor={`ritemb${index}`} className="cardmain">
                                                <div className="flx">
                                                    <p>
                                                        {global.storeConfigration?.enable_cardknox
                                                            ?.value === '1'
                                                            ? data.MaskedNumber
                                                            : 'xxxx-xxxx-xxxx-' + data.last4}
                                                    </p>
                                                    <div className="radio-item">
                                                        <label className="custom-checkbox">
                                                            <input
                                                                type="checkbox"
                                                                id={`ritemb${index}`}
                                                                name="ritem"
                                                                value={data.id}
                                                                checked={cardData === data.id}
                                                                onChange={onChangeCard}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                        {/* <span className="vcRad"></span> */}
                                                    </div>
                                                </div>
                                                <div className="flx">
                                                    <p>{data.brand}</p>
                                                    <p>
                                                        {data.exp_month}/{data.exp_year}
                                                    </p>
                                                </div>
                                            </label>
                                        </div>
                                    ))}
                            </div>
                            <p>
                                This purchase adds 5 extra business days—giving you 8 business days
                                total to pick up your item.
                            </p>
                        </div>
                        <PrimaryButton
                            label={paymentLoading ? 'Please wait...' : 'Pay'}
                            className="w-auto"
                            onClick={() => {
                                handleExtendedPickupPayment()
                            }}
                            disabled={paymentLoading}
                        />
                    </>
                }
            </Popup>
        </>
    )
}

export default InvoiceRecords
